/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Col, Row } from 'antd';
import useWindowSize from 'hooks/useWindowSize';
import { get } from 'lodash';
import React from 'react';
import { useHistory } from 'react-router';
import { GeneralFunction } from 'types/common';

import CardAvatar from './CardAvatar';
import CardBody from './CardBody';
import CardBodyMobile from './CardBodyMobile';
import { WidgetStyled } from './styled';
import { IDataCardProps } from './types';

const DataCard: React.FC<IDataCardProps> = (props) => {
  const {
    main = undefined,
    sub = undefined,
    extra,
    action = undefined,
    height = undefined,
    width = undefined,
    mobileWidth = undefined,
    mobileHeight = undefined,
    avatar = undefined,
    originAvatar = [],
    avatarSizes,
    avatarSizesMobile,
    status = undefined,
    statusTooltip = undefined,
    statusTooltipColor = undefined,
    hideAvatar = false,
    onClick = undefined,
    rightSide = undefined,
    className = '',
    responsive = false,
    mobileThreshold = undefined,
    style,
  } = props;

  const history = useHistory();
  const windowWidth = useWindowSize().width;

  const onActionToCardClick = (e: any, onClickHandler?: GeneralFunction) => {
    e.stopPropagation();
    if (onClickHandler) onClickHandler();
  };

  const onEdit = (e: any) => {
    onActionToCardClick(e, get(action, 'edit'));
  };
  const onCardClick = (e: any) => {
    onActionToCardClick(e, onClick);
  };
  const onDelete = (e: any) => {
    onActionToCardClick(e, get(action, 'delete'));
  };

  const onRedirect = () => {
    history.push(get(action, 'route', ''));
  };

  const isMobileView = !!mobileThreshold && windowWidth <= mobileThreshold;
  const isResponsiveView = isMobileView && responsive;

  const avatarSizesStyle = isResponsiveView
    ? { width: '100%', height: height || 'auto', ...avatarSizesMobile }
    : { width: 'auto', height: height || '100%', ...avatarSizes };

  return (
    <WidgetStyled
      style={style}
      $height={!isMobileView ? height : mobileHeight || 'auto'}
      $width={!isMobileView ? width : mobileWidth || '100%'}
      className={`gx-card-full gx-dot-arrow-hover ${className}`}>
      <div className='gx-user-wid-row' onClick={onCardClick} style={{ cursor: onClick ? 'pointer' : 'auto' }}>
        {!isResponsiveView && (
          <>
            {!hideAvatar && (
              <CardAvatar
                isMobile={isMobileView}
                avatarSizes={avatarSizesStyle}
                avatar={avatar}
                originAvatar={originAvatar}
              />
            )}
            <CardBody
              onDelete={action && action.delete ? onDelete : undefined}
              onEdit={action && action.edit ? onEdit : undefined}
              onRedirect={action && action.route ? onRedirect : undefined}
              main={main}
              sub={sub}
              extra={extra}
              status={status}
              statusTooltip={statusTooltip}
              statusTooltipColor={statusTooltipColor}
              rightSide={rightSide}
            />
          </>
        )}
        {isResponsiveView && (
          <Row
            style={{
              width: mobileWidth,
              height: mobileHeight,
            }}
            className='gx-m-0 gx-p-0'>
            <Col span={24} className='gx-flex-row gx-p-0'>
              {!hideAvatar && (
                <CardAvatar
                  isMobile={isMobileView}
                  avatarSizes={avatarSizesStyle}
                  avatar={avatar}
                  originAvatar={originAvatar}
                />
              )}
            </Col>
            <Col span={24}>
              <CardBodyMobile
                onDelete={action && action.delete ? onDelete : undefined}
                onEdit={action && action.edit ? onEdit : undefined}
                onRedirect={action && action.route ? onRedirect : undefined}
                main={main}
                sub={sub}
                extra={extra}
                status={status}
                statusTooltip={statusTooltip}
                statusTooltipColor={statusTooltipColor}
                rightSide={rightSide}
              />
            </Col>
          </Row>
        )}
      </div>
    </WidgetStyled>
  );
};
export default React.memo(DataCard);
